(function ($) {
  $(function () {

    // Start Cart Js
    var getUrlParameter = function getUrlParameter(sParam) {
      var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split("&"),
        sParameterName,
        i;
      for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split("=");
        if (sParameterName[0] === sParam) {
          return typeof sParameterName[1] === undefined
            ? true
            : decodeURIComponent(sParameterName[1]);
        }
      }
      return false;
    };
    var cart = getUrlParameter("cartr");
    if (cart == "y") {
      $("body").toggleClass("cart-shown");
    }

    // Start Home Js
    $(".hamburger").click(function () {
      $("body").toggleClass("navShown");
      $(".nav-wrap").fadeToggle();
    });

    $(".cart-btn").click(function () {
      $("body").addClass("cart-shown");
    });

    $(".close-area, .cart-close").click(function () {
      $("body").removeClass("cart-shown");
    });

    var header = new Headroom(document.querySelector("header"), {
      tolarence: 80,
      offset: 155,
      classes: {
        initial: "headroom",
        pinned: "slidedown",
        unpinned: "slideup",
      },
    });
    header.init();

    $(window).scroll(function () {
      yPos = window.pageYOffset;
      scrollFade = yPos * 0.4 + "px";
      $(".hero-inner").css({
        transform: `translateY(${scrollFade})`,
      });
      $(".hero-content").css("opacity", 1 - $(window).scrollTop() / 600);
    });

    if ($(".single-product__image-slider").length) {
      $(".single-product__image-slider").slick({
        dots: true,
        arrows: false,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        // Oct 2026 - these thumbnails are the gallery's dot controls. They used
        // to render an <img> with no alt attribute, which failed WCAG 1.1.1
        // eight to ten times on every product page. The image is decoration
        // (alt=""); the accessible name belongs on the button that does the
        // work. Do not move the name onto the img - it would be read twice.
        customPaging: function (slider, i) {
          return (
            '<button class="tab" type="button" aria-label="Show product image ' +
            (i + 1) +
            '"><img src="' +
            $(".product-image-slide:nth-child(" + (i + 1) + ")").data(
              "thumbnail-image"
            ) +
            '" alt="" width="140" height="140" /></button>'
          );
        },
      });
    }

    if ($("div.cocktails-item-wrap").length) {
      $("div.cocktails-item-wrap")
        .slick({
          dots: false,
          infinite: true,
          speed: 400,
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 8000,
          arrows: true,
          centerMode: false,
          centerPadding: false,
          fade: true,
          responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },

            {
              breakpoint: 481,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
          ],
        })
        .slickAnimation();
    }

    if ($(".product-item-wrap").length) {
      var $slider = $(".product-item-wrap");
      $slider.slick({
        arrows: false,
        dots: false,
        infinite: false,
        slidesToShow: 3,
        centerMode: false,
        vertical: false,

        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
              swipe: true,
              variableWidth: false,
            },
          },
          {
            breakpoint: 768,
            settings: {
              variableWidth: false,
              slidesToShow: 1,
            },
          },
        ],
      });

      $(window).on("resize", function () {
        $(".product-item-wrap").slick("resize");
      });
    }

    //Animate heading
    if ($(".split-heading").length) {
      var res = Splitting({
        target: ".split-heading",
        by: "lines",
      });

      Splitting();

      res.forEach((splitResult) => {
        const wrappedLines = splitResult.lines
          .map(
            (wordsArr) => `
            <span class="line"><span class="mask-up">
            ${wordsArr
              .map(
                (word) => `${word.outerHTML}<span class="whitespace">
            </span>`
              )
              .join("")}
            </span></span>`
          )
          .join("");
        splitResult.el.innerHTML = wrappedLines;
      });
      inView.threshold(500);
      inView(".split-heading").on("enter", function (el) {
        if (!el.classList.contains("has-animated")) {
          anime({
            targets: el.querySelectorAll(".mask-up"),
            translateY: ["100%", "0%"],
            duration: 600,
            delay: anime.stagger(200),
            easing: "easeOutQuad",
            autoplay: true,
          });
          el.classList.add("has-animated");
        }
      });
    }

    // ANIMATION CHECK IF IN VIEW
    var $animation_elements = $(".anim-el");
    var $window = $(window);
    function check_if_in_view() {
      var window_height = $window.height();
      var insetAmount = window_height / 20; // fifth of the screen
      var window_top_position = $window.scrollTop();
      var window_bottom_position =
        window_top_position + window_height - insetAmount;
      $.each($animation_elements, function () {
        var $element = $(this);
        var element_height = $element.outerHeight();
        var element_top_position = $element.offset().top;
        var element_bottom_position = element_top_position + element_height;
        //check to see if this current container is within viewport
        if (element_top_position <= window_bottom_position) {
          $element.addClass("in-view");
        }
      });
    }
    $window.on("scroll orientationchange resize", check_if_in_view);
    $window.trigger("scroll");
    const updateProperties = (elem, state) => {
      elem.style.setProperty("--x", `${state.x}px`);
      elem.style.setProperty("--y", `${state.y}px`);
      elem.style.setProperty("--width", `${state.width}px`);
      elem.style.setProperty("--height", `${state.height}px`);
      elem.style.setProperty("--radius", state.radius);
      elem.style.setProperty("--scale", state.scale);
    };

    if ($(window).width() < 769) {
      $(".side-nav ul li a, .our-range-item-content-btn a, .hero-btn a").on(
        "click",
        function (e) {
          let link = $(this).attr("href");
          let firstLetter = link.charAt(0);
          let url = window.location.origin + "/" + link;

          if (firstLetter == "#") {
            e.preventDefault();
            $("body").removeClass("navShown");
            $(".nav-wrap").hide(100);
          }
        }
      );
    }

    // var target = $($(this).attr('href'));
    // if (target.length) {
    //     var scrollTo = target.offset().top ;
    //     $('body, html').animate({
    //         scrollTop: scrollTo + 'px'
    //     }, 800);
    // }

    // Select all links with hashes
    $('a[href*="#"]')
      // Remove links that don't actually link to anything
      .not('[href="#"]')
      .not('[href="#0"]')
      .click(function (event) {
        // On-page links
        if (
          location.pathname.replace(/^\//, "") ==
            this.pathname.replace(/^\//, "") &&
          location.hostname == this.hostname
        ) {
          // Figure out element to scroll to
          var target = $(this.hash);
          target = target.length
            ? target
            : $("[name=" + this.hash.slice(1) + "]");
          // Does a scroll target exist?
          if (target.length) {
            // Only prevent default if animation is actually gonna happen
            event.preventDefault();
            $("html, body").animate(
              {
                scrollTop: target.offset().top - 40,
              },
              800
            );
          }
        }
      });

    $(".stockist-content-btn a").click(function (e) {
      e.preventDefault();
      $("body").addClass("where-to-buy-shown");
    });
    $(".order-crose-icon, .close-btn a").click(function (e) {
      e.preventDefault();
      $("body").removeClass("where-to-buy-shown");
    });
    // $('main').click(function(e){
    //     e.stopPropagation();

    // })
  }); // End ready function.
})(jQuery);

$(".accordion__title").click(function () {
  $(this).parent().find(".accordion__text").slideToggle();
  // $('.accordion__title').removeClass('accordion__show');
  $(this).toggleClass("accordion__show");
});

function increaseCount(e, i) {
  var i = i.previousElementSibling,
    t = parseInt(i.value, 10),
    t = isNaN(t) ? 0 : t;
  i.value = ++t;
}

function decreaseCount(e, i) {
  var i = i.nextElementSibling,
    t = parseInt(i.value, 10);
  1 < t && ((t = isNaN(t) ? 0 : t), (i.value = --t));
}

function increaseValue(e, i) {
  const t = e.parentElement.querySelector(".number");
  e = parseInt(t.innerHTML, 10);
  isNaN(e) && (e = 0), (i && i <= e) || (t.innerHTML = e + 1);
}

function decreaseValue(e) {
  const i = e.parentElement.querySelector(".number");
  e = parseInt(i.innerHTML, 10);
  (e = isNaN(e) ? 0 : e) < 2 || (i.innerHTML = e - 1);
}

$(".custom-review__items").slick({
  infinite: true,
  dots: false,
  slidesToShow: 1,
  slidesToScroll: 1,
});

var excludedPages = ["privacy-policy", "terms-and-conditions"];
var currentPath = window.location.pathname.toLowerCase();
var isExcludedPage = excludedPages.some(function (slug) {
  return currentPath.indexOf(slug) !== -1;
});
 
if (!isExcludedPage) {
  var ageVerified = Cookies.get("bc-age-verification");
  if (ageVerified === undefined) {
    $(".age-verification-section").fadeIn();
    $("body").addClass("verifying-age");
    $("body").bind("touchmove", function (e) {
      e.preventDefault();
    });
  }
}
 
$("#enter-site").on("click", function (e) {
  e.preventDefault();
  Cookies.set("bc-age-verification", "verified");
  $(".age-verification-section").fadeOut();
  $("body").removeClass("verifying-age");
  $("body").unbind("touchmove");
});


document.addEventListener('click', function (event) {
  var link = event.target.closest('a[href]');
  if (!link) return;
 
  var href = link.getAttribute('href');
 
  // Skip mailto:, tel:, javascript:, and anchor links (#section)
  if (!href || /^(mailto:|tel:|javascript:|#)/i.test(href)) return;
 
  var url;
  try {
    url = new URL(href, window.location.href);
  } catch (e) {
    return; // malformed URL, let the browser handle it normally
  }
 
  var isExternal = url.hostname !== window.location.hostname;
 
  if (isExternal) {
    event.preventDefault();
    window.open(url.href, '_blank', 'noopener,noreferrer');
  }
  // Internal links: do nothing, let them navigate normally
});

